export const salaryConfigEN = {
    "salary-config": {
        "title": "Payroll Type",
        "title-save": "Add type of payroll",
        "title-edit": "Edit payroll type",
        "title-view": "Details of payroll type",
        "fields": {
            "main": "Main",
            "extra": "Extra",
            "day" : "Day",
            "name" : "Name of payroll type",
            "other-tables" : "Link to other payroll",
            "keyword" : "Representative keywords",
            "apply-department" : "Department of application",
            "apply-position" : "Applicable location",
            "salaryType" : "Payroll",
            "report" : "Payroll to report",
            "employee-manage" : "Manager",
            "employee-follow" : "Followers",
            "autoGenerated-checked" : "Automatically generate monthly payroll",
            "autoGenerated" : "Automatically generated on date",
            "columnName" : "Pillar",
            "valueColumn" : "Column value",
            "titleColumn" : "Column Headers",
            "keyColumn" : "Column keyword",
            "calculation" : "Calculation (Formula/Constant)",
            "rowValue" : "Value of the aggregate row when splitting lines",
            "typeValue" : "Value type",
            "paycheck" : "Paycheck",
            "valueSynthetic" : "Aggregate value",
            "describe" : "Describe",
            "report-value-yes" : "Yes",
            "report-value-no" : "No",
            "creatorDay" : "Date created",
            "employeeCreator" : "Creator"
        },
        "placeholder" : {
            "employee-manage" : "Select personnel to manage payroll",
            "employee-follow" : "Select personnel to monitor payroll",
            "autoGenerated" : "Choose a date",
            "valueColumn" : "Select column.js value",
            "keyColumn" : "Enter keywords",
            "rowValue" : "Choose ...",
            "typeValue" : "Number or letter",
            "paycheck" : "Choose a form"
        },
        "rowValue" : {
            "totalrows" : "Total rows" ,
            "minvaluerows" : "Minimum value of rows",
            "maxvaluerows" : "Maximum value of rows",
            "valuelastrow" : "Value of the last row",
            "mediumvaluerows" : "Average value of rows",
            "formula" : "Formula"
        },
        "typeValue" :{
            "number" : "Numeric form",
            "word" : "Typeface"
        },
        "paycheck" :{
            "presently" : "Presently",
            "hide" : "Hide"
        },
        "valueSynthetic" : {
            "sumrowvalues" : "Total row values",
            "minvaluerow" : "Minimum value of rows",
            "maxvaluerow" : "Maximum value of rows",
            "mediumvaluerows" : "Average value of rows"
        },
        "message" :{
            "add" : "Add successful payroll type!",
            "edit" : "Correction of payroll type successful!"
        }
    },
}